import { createRoute, type AnyRoute } from "@tanstack/react-router";
import { Database } from "lucide-react";

import type { FeatureModule } from "@/features/types";
import { guarded } from "@/lib/auth";

import { DatabasePage } from "./pages/DatabasePage";

export const dbExplorerModule: FeatureModule = {
  key: "db_explorer",
  nav: {
    label: "Database",
    icon: Database,
    to: "/database",
    requires: "db_explorer.read",
    // Tools group, alongside Design System / Glossary.
    order: 122,
    group: "Tools",
  },
  routes: (rootRoute) => [
    createRoute({
      getParentRoute: () => rootRoute,
      path: "/database",
      component: guarded("db_explorer.read", DatabasePage),
    }),
  ] as unknown as AnyRoute[],
};
